import {
  GoalFilterDocument,
  GoalSortingMode,
  GroupByMode,
} from '@griply/types';

export type GoalListControlSource = {
  goalFilterDocument?: GoalFilterDocument | null;
  goalSortingMode?: GoalSortingMode | null;
};

// The entity's `goalSortingMode` (not the document) drives the list sort.
export const getGoalListControlDocument = ({
  goalFilterDocument,
  goalSortingMode,
}: GoalListControlSource): GoalFilterDocument => ({
  ...(goalFilterDocument ?? {}),
  sortingMode:
    goalFilterDocument?.sortingMode ??
    goalSortingMode ??
    GoalSortingMode.StartDate,
  groupByMode: goalFilterDocument?.groupByMode ?? GroupByMode.None,
  filters: goalFilterDocument?.filters ?? null,
});
